import { useQueryClient } from "@tanstack/react-query";
import { useMapUnknownSecurity } from "src/services/admin/commands/unknownSecurities";
import SnackbarUtils from "src/utils/SnackbarUtils";

import { useGetUnknownQueryKey } from "../hooks/useGetUnknownQueryKey";

export const useSaveSecurity = () => {
	const key = useGetUnknownQueryKey();
	const queryClient = useQueryClient();

	const onSuccess = () => {
		SnackbarUtils.success("Se ha guardado la acción.");
		queryClient.invalidateQueries({
			queryKey: key
		});
	};

	const onError = () => {
		SnackbarUtils.error("Se ha producido un error al intentar guardar la acción.");
	};

	const { mutate, isPending } = useMapUnknownSecurity(onSuccess, onError);

	return { mutate, isLoading: isPending };
};
